module.exports = __webpack_public_path__ + "media/images/icons/vi-c79ba4c33bf3261e5cee4dd55b99acf4.png";